export default (
    state = {
        loading: false,
        defaultResponse: true,
        Success: false
    },
    action) => {

     switch (action.type) {

        case 'DELETE_CC_DATA_REQUEST':
            return {
                ...state,
                loading: true,
                defaultResponse: true,
                Success: false
            }

        case 'DELETE_CC_DATA_SUCCESS':
            return {
                ...state,
                Success: action.payload.Success,
                message: action.payload.message,
                loading: false,
                defaultResponse: false,
            };

        case 'DELETE_CC_DATA_FAILURE':
            return {
                ...state,
                error: true,
                Success: false,
                message: action.payload.response.data.message,
                userMessage: action.payload.response.data['usermessage'],
                loading: false,
                defaultResponse: false,
            };

        default:

            return state;

    }

};